import useAPI from '../../hooks/useAPI';
import AnimatedSection from '../common/AnimatedSection';

/* ─── Main Component ───────────────────────────────────────── */
const TeamOnly = () => {
  const {
    data: teamData,
    loading,
    error,
  } = useAPI('/team');

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // const team = teamData?.data || teamData; // adjust based on API structure
  console.log("API URL:", teamData);
  return(
    <section id="team" className="relative bg-white py-24 overflow-hidden">
      {/* Subtle Background Accent */}
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-indigo-50/50 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* Section Header */}
        <AnimatedSection>
          <div className="text-center mb-20">
            <span className="text-primary text-[11px] font-black tracking-[0.2em] uppercase mb-3 block">
              Expert Leadership
            </span>
            <h2 className="text-4xl md:text-6xl font-extrabold text-dark tracking-tighter leading-tight">
              The Minds Behind <span className="text-primary italic">BTI.</span>
            </h2>
            <div className="w-12 h-1.5 bg-primary mx-auto mt-8 rounded-full" />
          </div>
        </AnimatedSection>

        {/* Team Grid - Static Layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {teamData?.data?.map((member, i) => (
            <AnimatedSection key={i} delay={0.1 * i}>
              <div className="text-center">
                {/* Image Container: Rounded with Border, No Grayscale/Hover */}
                <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-slate-50 mb-6 border border-slate-100 shadow-sm">
                  <img 
                    src={member?.image} 
                    alt={member?.name} 
                    className="w-full h-full object-cover" 
                  />
                </div>
                
                {/* Typography: Clean and Static */}
                <h4 className="font-bold text-dark text-lg md:text-xl">
                  {member?.name}
                </h4>
                <p className="text-[10px] md:text-xs text-dark/40 font-bold uppercase tracking-[0.15em] mt-2">
                  {member?.designation}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>

      </div>
    </section>
  )
}

export default TeamOnly;